(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-recommendations"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async function(event) {
  const button = event.target.closest('.qv-addon-add');
  if (!button || button.disabled) return;
  const card = button.closest('.qv-addon');
  const variant = card.querySelector('.qv-addon-variant');
  const message = card.querySelector('.qv-addon-message');
  button.disabled = true;
  button.textContent = 'Adding…';
  message.textContent = '';
  try {
    const response = await fetch(button.dataset.addUrl, {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({items: [{id: Number(variant.value), quantity: 1}]})
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || 'Unable to add this item. Please try again.');
    window.location.assign(button.dataset.cartUrl);
  } catch (error) {
    message.textContent = error.message;
    button.disabled = false;
    button.textContent = 'Add to cart';
  }
});
  } catch(e) { console.error(e); }
})();

})();
